import { Link } from 'react-router-dom';
import { categories } from '@/mocks/anime';

export default function CategorySection() {
  return (
    <section className="mx-auto w-full max-w-6xl px-4 md:px-6 py-12 md:py-16">
      <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
        <div>
          <p className="text-sm font-medium text-primary-600">CATEGORY</p>
          <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">动漫分类导航</h2>
        </div>
        <Link to="/category" className="flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
          查看全部 <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((c) => (
          <Link
            key={c.id}
            to={`/category/${c.id}`}
            className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-gradient-to-br from-primary-500 to-accent-500 text-background-50">
              <i className={`${c.icon} text-xl`} aria-hidden="true" />
            </span>
            <div className="min-w-0 flex-1">
              <h3 className="font-heading text-lg text-foreground-950">{c.name}</h3>
              <p className="mt-0.5 truncate text-sm text-foreground-500">{c.desc}</p>
            </div>
            <span className="flex items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900 whitespace-nowrap">
              {c.count} 部
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}